/** Philips Device Connector — Chrome Web Store */
export const PHILIPS_PDC_EXTENSION_STORE_URL =
  "https://chromewebstore.google.com/detail/philips-device-connector/okdioccnnkeanlegkfgnnboncggagfjh";

/** Official setup guide (extension + native host) */
export const PHILIPS_PDC_SETUP_GUIDE_URL =
  "https://www.dictation.philips.com/fileadmin/Products/pcl8000/ifu/guide/index.html";

/** Native host application downloads */
export const PHILIPS_PDC_NATIVE_HOST_DOWNLOAD_URL =
  "https://www.dictation.philips.com/fileadmin/Products/pcl8000/ifu/guide/en/downloads.html";
